export const CRMItems = [
    {
      "description": "Gym Management Software",
      "long_description": "",
      "rate": "Rs.12,000.00",
      "tax_1": "9.00%",
      "tax_2": "9.00%",
      "unit": "9.00%",
      "group_name": "",
      "hsn": "Software"
    },
    {
      "description": "2 Door Controller",
      "long_description": "2 Door Controller for Door access & Integration with Boom Barriers",
      "rate": "Rs.16,500.00",
      "tax_1": "9.00%",
      "tax_2": "9.00%",
      "unit": "9.00%",
      "group_name": "",
      "hsn": "Hardware"
    },
    {
      "description": "NBP-300 Billing System",
      "long_description": "2\" Thermal Printers",
      "rate": "Rs.13,500.00",
      "tax_1": "9.00%",
      "tax_2": "9.00%",
      "unit": "9.00%",
      "group_name": "",
      "hsn": "Hardware"
    }
  ]
  